<template>
  <div class="loginGuidance">
    <div class="guidance_mask">
      <div class="guodance_sign" v-if="showIndex == 1">
        <img class="signHome_j" src="../../assets/images/guidance/signHome_j.png" />
        <div class="guodance_sign_bg">
          <h3>签约服务模块</h3>
          <div class="text_list">
            <b></b><p style="padding-left:12px;">可进行贷款合同的发起、签署与管理；</p> 
          </div>
          <div class="text_list">
            <b></b> <p>借款人可在此处针对已完成签约的赋强贷款合同申请赋强公证；</p>
          </div>
          <div class="text_list">
            <b></b> <p style="padding-left:13px;">金融机构可在此处对已完成赋强公证的赋强贷款合同发起履约任务管理。</p>
          </div>
          <div class="guodance_sign_bottom">
            <p @click="closeShowIndex">跳过指引（{{showIndex}} / {{allIndex}}）</p>
            <button type="button" @click="changeShowIndex(2)">下一步</button>
          </div>
        </div>
      </div>
      <div class="guodance_sign" v-if="showIndex == 2">
        <img class="signHome_j service_j" src="../../assets/images/guidance/signHome_j.png" />
        <div class="guodance_sign_bg service_sign_bg">
          <h3>公证服务模块</h3>
          <div class="text_list">
            <b></b> <p style="padding-left:13px;">查看与自己相关的赋强公证、强执公证状态，并进行电子公证书的下载等操作。</p>
          </div>
          <div class="guodance_sign_bottom">
            <p @click="closeShowIndex">跳过指引（{{showIndex}} / {{allIndex}}）</p>
            <button type="button" @click="changeShowIndex(3)">下一步</button>
          </div>
        </div>
      </div>
      <div class="guodance_sign" v-if="showIndex == 3">
        <img class="signHome_j performance_j" src="../../assets/images/guidance/signHome_j.png" />
        <div class="guodance_sign_bg performance_sign_bg">
          <h3>履约管理模块</h3>
          <div class="text_list">
            <b></b> <p style="padding-left:13px;">查看与自己相关的赋强公证、强执公证状态，并进行电子公证书的下载等操作。</p>
          </div>
          <div class="guodance_sign_bottom">
            <p @click="closeShowIndex">跳过指引（{{showIndex}} / {{allIndex}}）</p>
            <button type="button" @click="changeShowIndex(4)">下一步</button>
          </div>
        </div>
      </div>
      <div class="guodance_sign" v-if="showIndex == 4">
        <img class="signHome_j user_center_j" src="../../assets/images/guidance/signHome_j.png" />
        <div class="guodance_sign_bg user_center_sign_bg">
          <h3>用户中心模块</h3>
          <div class="text_list">
            <b></b> <p style="padding-left:13px;">提供了个人账号管理，实名认证，密码修改，余额充值，签章管理等功能。</p>
          </div>
          <div class="guodance_sign_bottom">
            <p @click="closeShowIndex">跳过指引（{{showIndex}} / {{allIndex}}）</p>
            <button type="button" @click="changeShowIndex(5)">下一步</button>
          </div>
        </div>
      </div>
      <!-- <div class="guodance_sign" v-if="showIndex == 5">
        <img class="signHome_j report_form_j" src="../../assets/images/guidance/top_j.png" />
        <div class="guodance_sign_bg report_form_sign_bg">
          <h3>报表中心模块</h3>
          <div class="text_list">
            <b></b> <p style="padding-left:13px;">可以查看你日常申请的所有数据导出需求，我们的数据导出请求保留3个月，过期需重新申请。</p>
          </div>
          <div class="guodance_sign_bottom">
            <p @click="closeShowIndex">跳过指引（{{showIndex}} / {{allIndex}}）</p>
            <button type="button" @click="changeShowIndex(6)">下一步</button>
          </div>
        </div>
      </div>
      <div class="guodance_sign" v-if="showIndex == 6">
        <img class="signHome_j help_center_j" src="../../assets/images/guidance/top_j.png" />
        <div class="guodance_sign_bg help_sign_bg">
          <h3>帮助中心模块</h3>
          <div class="text_list">
            <b></b> <p style="padding-left:13px;">日常使用过程中有遇到任何问题都可在此处找</p>
          </div>
          <div class="guodance_sign_bottom">
            <p @click="closeShowIndex">跳过指引（{{showIndex}} / {{allIndex}}）</p>
            <button type="button" @click="changeShowIndex(7)">下一步</button>
          </div>
        </div>
      </div> -->
      <div class="guodance_sign" v-if="showIndex == 5">
        <img class="number_j" src="../../assets/images/guidance/top_j.png" />
        <div class="guodance_sign_bg number_center_sign_bg">
          <h3>账号模块</h3>
          <div class="text_list">
            <b></b> <p style="padding-left:13px;">提供了多主体账号切换功能，完成对应账号的实名认证后即可根据需求切换个人、机构不同身份进行功能使用</p>
          </div>
          <div class="guodance_sign_bottom">
            <p @click="closeShowIndex">（{{showIndex}} / {{allIndex}}）</p>
            <button type="button" @click="changeShowIndex(5)">我知道了</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showIndex: 1,//当前引导数
      allIndex: 5//引导步骤总数
    };
  },
  mounted() {},
  methods: {
    changeShowIndex(index) {
      if (index == this.showIndex) {
        this.closeShowIndex();
        return;
      }
      this.showIndex = index;
      this.$emit("showIndex", index);
    },
    closeShowIndex() {
      this.$emit("closeGuide", false);
    }
  }
};
</script>
<style lang="scss" scoped>
.loginGuidance {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  z-index: 200;
  .guidance_mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6000);
    position: relative;
    .guodance_sign {
      .signHome_j {
        width: 127px;
        height: 11px;
        position: absolute;
        top: 149px;
        left: 183px;
      }
      .service_j {
        top: 225px;
        left: 183px;
      }
      .performance_j {
        top: 188px;
        left: 183px;
      }
      .user_center_j {
        top: 266px;
        left: 183px;
      }
      .number_j{
         width: 12px;
        height: 128px;
        position: absolute;
        top: 38px;
        right: 87px; 
        left:auto;
      }
      .report_form_j{
         width: 12px;
        height: 128px;
        position: absolute;
        top: 38px;
        right: 336px;
        left:auto; 
      }
      .help_center_j{
        width: 12px;
        height: 128px;
        position: absolute;
            top: 38px;
    right: 227px; 
        left:auto; 
      }
      .guodance_sign_bg {
        padding: 20px;
        width: 439px;
        padding-left: 40px;
        min-height: 106px;
        background: url("../../assets/images/guidance/signHome_mask.png");
        background-position: center center;
        background-size: 100% 100%;
        position: absolute;
        top: 104px;
        left: 314px;
        h3 {
          font-size: 20px;
          color: #000000;
          line-height: 26px;
          margin-bottom: 10px;
        }
        .text_list {
          font-size: 14px;
          color: #4f4f4f;
          line-height: 24px;
          height: 30px;
          b {
            width: 6px;
            height: 6px;
            background: #cc0404;
            border-radius: 50%;
            display: inline-block;
            float: left;
            margin-top: 8px;
            margin-right: 8px;
          }
        }
        .guodance_sign_bottom {
          width: 100%;
          margin-top: 30px;
          display: flex;
          height: 36px;
          justify-content: space-between;
          align-items: center;
          p {
            font-size: 14px;
            color: #b2afaf;
            cursor: pointer;
          }
          button {
            width: 96px;
            height: 36px;
            background: #d01f1f;
            border-color: #d01f1f;
            border-radius: 4px;
            color: #fff;
            font-size: 18px;
            cursor: pointer;
          }
        }
      }
      .service_sign_bg {
        top: 194px;
        left: 314px;
      }
      .performance_sign_bg {
        top: 158px;
        left: 314px;
      }
      .user_center_sign_bg {
        top: 235px;
        left: 314px;
      }
      .number_center_sign_bg{
        padding: 20px;
        width: 313px;
        min-height: 106px;
        background: url("../../assets/images/guidance/number_mask.png");
        background-position: center center;
        background-size: 100% 100%;
        position: absolute;
        top: 169px;
        right: 23px;
        left: auto;
        .guodance_sign_bottom{
            margin-top:40px;
        }
      }
      .report_form_sign_bg{
        padding: 20px;
        width: 313px;
        min-height: 106px;
        background: url("../../assets/images/guidance/top_mask.png");
        background-position: center center;
        background-size: 100% 100%;
        position: absolute;
        top: 169px;
        right: 166px;
        left: auto;
        .guodance_sign_bottom{
            margin-top:40px;
        }
      }
      .help_sign_bg{
        padding: 20px;
        width: 313px;
        min-height: 106px;
        background: url("../../assets/images/guidance/top_mask.png");
        background-position: center center;
        background-size: 100% 100%;
        position: absolute;
        top: 169px;
        right: 58px;
        left: auto;
        .guodance_sign_bottom{
            margin-top:40px;
        }
      }
    }
  }
}
</style>